import {db} from '../firebase'
import Vue from 'vue'
import router from '../router'
import store from '../store'

export default {
    namespaced: true,
    state: {
        notices: [],
        currentNotice: [],
        filters:{
            categories:[],
        }
    },
    mutations: {
        setNotices(state, notices){
            state.notices = notices
        },
        setCurrentNotice(state, notice){
            state.currentNotice = notice
        },
        setSelectedCategories(state, categories){
            state.filters.categories = categories
        },
    },
    actions: {
        doPublish({rootState}, {id, title, thumbnail, description, categories}){
            try{
                const noticeRef = db.collection('notices').doc(id)
                noticeRef.set({
                    title,
                    thumbnail,
                    categories,
                    createdAt: Date.now(),
                    noticeId: id,
                    userId: rootState.user.user.uid
                })
                noticeRef.collection('data').doc('single').set({
                    title,
                    thumbnail,
                    categories,
                    createdAt: Date.now(),
                    description
                })
                Vue.$toast.success('La noticia fue subida')
                router.push({name: 'Dashboard'})
            }catch(error){
                Vue.$toast.error('Hubo un problema al subir la noticia, intenta nuevamente más tarde')
                console.error(error)
            }
        },
        getNoticeId(){
            return db.collection('notices').doc().id
        },
        async getNotices({commit}, limit){
            const noticesRef = await db.collection('notices').orderBy('createdAt', 'desc').limit(limit).get()
            var notices = []
            noticesRef.forEach((notice)=>{
                notices.push(notice.data())
            })
            commit('setNotices', notices)
        },
        async getNotice({commit}, {title, createdAt}){
            createdAt = parseInt(createdAt, 10)
            const noticeRef = await db.collection('notices').where('title', '==', title).where('createdAt', '==', createdAt).get()
            if(!noticeRef.empty){
                const notice = await db.collection('notices').doc(noticeRef.docs[0].id).collection('data').doc('single').get()
                commit('setCurrentNotice', notice.data())
            }else{
                router.push({name: 'Home'})
            }
        },
        async getNoticeById({commit}, id){
            const notice = await db.collection('notices').doc(id).collection('data').doc('single').get()
            if(notice.exists){
                commit('setCurrentNotice', notice.data())
                return notice.data()
            }else{
                router.push({name: 'Home'})
            }
        },
        doUpdate(context, {id, title, thumbnail, description, categories}){
            try{
                const noticeRef = db.collection('notices').doc(id)
                noticeRef.update({
                    title,
                    thumbnail,
                    categories,
                })
                noticeRef.collection('data').doc('single').update({
                    title,
                    thumbnail,
                    description,
                    categories
                })
                Vue.$toast.success('La noticia fue editada')
                router.push({name: 'Dashboard'})
            }catch(error){
                Vue.$toast.error('Hubo un problema al editar la noticia, intenta nuevamente más tarde')
                console.error(error)
            }
        },
        async doDelete({dispatch}, id){
            const noticeRef = db.collection('notices').doc(id)
            const notice = await noticeRef.collection('data').doc('single').get()  
            const noticeData = notice.data()

            store.dispatch('utils/deleteFileFromUrl', noticeData.thumbnail)
            

            noticeRef.collection('data').doc('single').delete()
            noticeRef.delete()
            dispatch('getNotices', Infinity)
        }
    },
}